import { useEffect } from "react";
import { AnalyticsEvent } from "@common/constants/analytics-events";
import { useUser } from "@hooks/useUser";
import { trackEvent } from "@lib/analytics";
import { useUpdateUserMutation } from "@api/user.api";

export function useEmailVerifiedTracking() {
    const updateUserMutation = useUpdateUserMutation();
    const { email, avatar, eventsTriggered } = useUser();

    useEffect(() => {
        if (!email) {
            return;
        }

        if (eventsTriggered?.emailVerified) {
            return;
        }

        updateUserMutation.mutate({
            eventsTriggered: {
                ...eventsTriggered,
                emailVerified: true,
            },
        });

        void trackEvent(AnalyticsEvent.SIGNUP_EMAIL_VERIFIED, {
            method: avatar ? "google" : "app", // users who singed up with google will have an avatar
            email,
        });
    }, [avatar, email, eventsTriggered, updateUserMutation]);
}
